import BaseProgram from "./base";
import { Copies } from "../../../../../../../shared/hooks/useCopies";
import { StaticDataObject } from "../../../../../../../context/staticData/staticData";
import SelectableType from "../../../../../../../shared/enums/SelectableType";
import { Column } from "react-table";
import { ApiParticipantForSelectionForAdminResponse } from "../../../../../../../shared/types/ApiParticipantForSelectionForAdminResponse";
import CellEllipsis from "../../../../../../../shared/core/Table/components/cellEllipsis";
import ConnectionsProgramStatus from "shared/enums/ConnectionsProgramStatus";
import { StateStatus } from "shared/enums/StateStatus";

export default class ConnectionsProgram extends BaseProgram {
  canShowNoShowFilter(): boolean {
    return false;
  }
  canAdminMarkAsNoShow(): boolean {
    return false;
  }
  canShowAdditionalMeetingMatching(): boolean {
    return false;
  }
  canAddSponsorship(): boolean {
    if (this.programDetails) {
      return ConnectionsProgramStatus.isBetweenEnrollmentAndInProgress(
        this.programDetails.programStatus as ConnectionsProgramStatus
      );
    }
    return false;
  }
  getTableColumnsInListForSelectionRoundOne(
    copies: Copies,
    staticDataObj: StaticDataObject,
    selectableType: SelectableType
  ): Column<ApiParticipantForSelectionForAdminResponse>[] {
    return [
      ...this.getCommonColumnsForSelectionRounds(copies, staticDataObj, selectableType),
      {
        id: "hosted-selection-count",
        sortType: "basic",
        Header: copies.get("general.selection.count"),
        accessor: "requestCount",
        width: 180,
        Cell: CellEllipsis
      },

      {
        id: "status",
        Header: copies.get("status"),
        accessor: d => staticDataObj.activityStatus?.[d.selectionStatus],
        width: 180,
        Cell: CellEllipsis
      }
    ];
  }
  canManageMeetingCap(): boolean {
    return false;
  }
  canViewMeetingPurchases(): boolean {
    return false;
  }
  canRemoveOrgFromProgram(): boolean {
    return false;
  }
  canSendNotification(): boolean {
    return this.checkProgramState(ConnectionsProgramStatus.CONFIGURATION, StateStatus.ELAPSED);
  }
}
